import axios from 'axios'
import './axiosConfig' // Ensures interceptors are registered

const XLSX_MIME =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

interface BlobDownloadOptions {
  method?: 'get' | 'post'
  body?: unknown
  onProgress?: (percent: number) => void
}

/**
 * Fetch an Excel export as a blob and hand it to the browser as a download. The
 * filename comes from Content-Disposition, falling back to defaultFilename.
 */
export const downloadBlob = async (
  url: string,
  defaultFilename: string,
  { method = 'post', body = {}, onProgress }: BlobDownloadOptions = {}
): Promise<void> => {
  const config = {
    responseType: 'blob' as const,
    onDownloadProgress: (progressEvent: { loaded: number; total?: number }) => {
      if (onProgress && progressEvent.total) {
        onProgress(
          Math.round((progressEvent.loaded * 100) / progressEvent.total)
        )
      }
    },
  }
  const res =
    method === 'get'
      ? await axios.get(url, config)
      : await axios.post(url, body, {
          ...config,
          headers: { 'Content-Type': 'application/json' },
        })

  const disposition = res.headers['content-disposition']
  let filename = defaultFilename
  if (disposition) {
    const match = disposition.match(/filename="?([^";\n]+)"?/)
    if (match?.[1]) filename = match[1]
  }

  const blob = new Blob([res.data], { type: XLSX_MIME })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = filename
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  setTimeout(() => {
    document.body.removeChild(link)
    window.URL.revokeObjectURL(link.href)
  }, 1000)
}
